/**************************************************************************************************/
/** @import Node Packages                                                                        **/
/**************************************************************************************************/
import { defineComponent } from 'vue'

/**************************************************************************************************/
/** @internal Const @name Spinner                                                                **/
/**************************************************************************************************/
const Spinner = defineComponent(
{
	/*************************************************/
	/** @Properties                                 **/
	/*************************************************/
	name: 'Spinner',

	props:
	{
		border: { type: String, default: '.35rem' },
		show: { type: Boolean, default: true },
		size: { type: String, default: '3rem' },
		variant: { type: String, default: 'success' }
	},

	/*************************************************/
	/** @Methods                                    **/
	/*************************************************/
	methods:
	{
		GetStyle() : string
		{
			const { border, size } = this.$props
			return `
				border-width: ${ border };
				height: ${ size };
				width: ${ size };
			`
		}
	}
})

/**************************************************************************************************/
/** @export Component @name Spinner                                                              **/
/**************************************************************************************************/
export default Spinner

/**************************************************************************************************/
/** @export Type @name SpinnerRef                                                                **/
/**************************************************************************************************/
export type SpinnerRef = InstanceType<typeof Spinner>